module.exports = __webpack_public_path__ + "static/media/036.615ac8c7.jpg";